module.exports = __webpack_public_path__ + "img/0250_paper_co_cyan_papar.0e9f1569.png";